import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { initializeDesktopInstall } from './services/desktopInstall';
import './styles/base.css';
import { configureCapacitorDocumentBase } from './utils/capacitorRuntime.mjs';

const buildTarget = process.env.VUE_APP_BUILD_TARGET === 'h5' ? 'h5' : 'web';
document.documentElement.dataset.buildTarget = buildTarget;
window.JC_CLIENT_BUILD_TARGET = buildTarget;
configureCapacitorDocumentBase(window.JC_WEB_IM_CONFIG, document);

initializeDesktopInstall();

createApp(App).use(createPinia()).mount('#app');
